import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CategoriesHeader from "./header/CategoriesHeader.jsx";
import SearchResults from "./header/SearchResults.jsx";
import { navItems } from "../../data/categories";
import MobileMenu from "./header/MobileMenu.jsx";
import Backdrop from "../common/Backdrop.jsx";
import useBodyScrollLock from "../../hooks/useBodyScrollLock.js";
import useHandleCartDrawer from "../../hooks/useHandleCartDrawer.js";
import AuthModal from "../../features/auth/components/AuthModal.jsx";
import { fetchLogout } from "../../features/auth/authSlice";
import { clearCart, openCart } from "../../features/cart/cartSlice.js";
import ConfirmModal from "../ui/ConfirmModal.jsx";
import UserDropdown from "./header/UserDropdown.jsx";
import { searchProducts } from "../../features/product/productSlice.js";
import {
    SearchIcon, CartIcon, UserIcon,
    MenuIcon, DropdownIcon, FlashIcon,
} from "../../assets/icons/index.jsx";
import LocationSelector from "../common/LocationSelector.jsx";
function HeaderComponent() {
    const [showSearch, setShowSearch] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [authOpen, setAuthOpen] = useState(false);
    const [logoutOpen, setLogoutOpen] = useState(false);
    const [searchKey, setSearchKey] = useState("");
    const dispatch = useDispatch();
    const { user, authChecked, loading } = useSelector((state) => state.auth);

    // cart from Redux — not context
    const { product } = useSelector((state) => state.cart);
    const cartCount = product.reduce((total, item) => total + (Number(item.qty) || 1), 0);

    const { openCartDrawer } = useHandleCartDrawer();
    useBodyScrollLock(showSearch);

    const handleLogout = async () => {
        await dispatch(fetchLogout());
        dispatch(clearCart()); // Redux clearCart
        setLogoutOpen(false);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (searchKey.trim()) {
                dispatch(searchProducts(searchKey))
            }

        }, 2000);

        return () => clearTimeout(timer)
    }, [searchKey, dispatch]);




    return (
        <header className="w-full bg-[var(--primary-dark)] relative">
            <div className="max-w-[1800px] mx-auto px-6 lg:px-10 h-[112px] flex items-center justify-between">

                {/* Left Side Mobile */}
                <div className="flex items-center gap-4 lg:hidden">
                    <button onClick={() => setMenuOpen(true)} className="text-[var(--text-light)]">
                        <MenuIcon size={28} />
                    </button>
                    <div className="flex items-center shrink-0">
                        <img src="https://apsensyscare.com/website-logo-200-100.png" alt="" className="w-[6rem]" />
                    </div>
                </div>

                {/* Desktop Logo */}
                <div className="hidden lg:flex items-center shrink-0">
                    <img src="https://apsensyscare.com/website-logo-200-100.png" alt="" className="w-[6rem]" />
                </div>

                {/* Desktop Navigation */}
                <nav className="hidden lg:flex items-center gap-10 xl:gap-12">

                     <LocationSelector setAuthOpen={setAuthOpen}/>
                    <div className="relative group">
                        <button
                            className="flex items-center gap-1 text-[16px] font-medium text-[var(--text-light)]"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                        >
                            Categories
                            <DropdownIcon size={15} />
                        </button>
                        <CategoriesHeader />
                    </div>


                    {navItems.map((item) => (
                        <a key={item} href="#"
                            className="text-[16px] font-medium text-[var(--text-light)] hover:opacity-80 transition"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                        >
                            {item}
                        </a>
                    ))}
                </nav>

                {/* Right Side */}
                <div className="flex items-center gap-6 shrink-0 relative">

                    <Backdrop isOpen={showSearch} onClose={() => setShowSearch(false)} />

                    {/* Search */}
                    <div className="relative">
                        <div className={`absolute right-0 top-1/2 -translate-y-1/2
                            flex items-center rounded-full overflow-hidden
                            transition-all duration-500 ease-in-out z-[3]
                            ${showSearch
                                ? "md:w-[25rem] w-[15rem] bg-white px-4 py-2 shadow-lg"
                                : "h-[44px] justify-center bg-transparent"
                            }`}
                        >
                            <button
                                onClick={() => setShowSearch(!showSearch)}
                                className={`shrink-0 ${showSearch ? "text-[var(--primary-dark)]" : "text-[var(--text-light)]"}`}
                            >
                                <SearchIcon size={22} />
                            </button>
                            <input
                                onChange={(e) => setSearchKey(e.target.value)}
                                type="text"
                                placeholder="Search..."
                                autoFocus={showSearch}
                                className={`bg-transparent outline-none text-[16px] ml-3 transition-all duration-300
                                    ${showSearch ? "w-full opacity-100 text-black" : "w-0 opacity-0"}`}
                            />
                        </div>
                        {showSearch && (
                            <div className="absolute right-0 md:w-[25rem] w-[15rem] top-[20px] z-[5]">
                                <SearchResults />
                            </div>
                        )}
                    </div>


                    <div onClick={() => dispatch(openCart())} className="flex relative cursor-pointer">
                        <span className="bg-[var(--primary-soft)] text-md font-semibold rounded-full w-5 h-5 text-center absolute z-2 md:right-[-6px] top-[-7px]  right-[-9px] ">
                            {cartCount}
                        </span>
                        <button className="text-[var(--text-light)] z-1">
                            <CartIcon size={24} />
                        </button>
                    </div>

                    {/* Auth */}
                    {authChecked && (
                        user ? (
                            <UserDropdown onLogout={() => setLogoutOpen(true)} />
                        ) : (
                            <button
                                onClick={() => setAuthOpen(true)}
                                className="items-center text-[var(--text-light)] cursor-pointer"
                            >
                                Sign In
                            </button>
                        )
                    )}
                </div>
            </div>

            <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
            <AuthModal isOpen={authOpen} onClose={() => setAuthOpen(false)} />
            <ConfirmModal
                isOpen={logoutOpen}
                onClose={() => setLogoutOpen(false)}
                onConfirm={handleLogout}
                loading={loading}
                title="Logout?"
                message="Are you sure you want to logout from Apsensys Care?"
            />
        </header>
    );
}

export default HeaderComponent;